export default __webpack_public_path__ + "static/media/ic_search_primary.a7d91959.svg";